import { LOCAL_STORAGE_ONBOARDING_SKIPPED_KEY } from './constants'

export const ONBOARDING_SKIP_EXPIRATION_MS = 24 * 60 * 60 * 1000 // 24 h

/**
 * Checks if buyer onboarding was skipped and is still within expiration period
 * @returns True if onboarding should be skipped (unexpired), false otherwise
 */
export const isBuyerOnboardingSkipActive = (): boolean => {
  const onboardingSkippedTimestamp = localStorage.getItem(LOCAL_STORAGE_ONBOARDING_SKIPPED_KEY)

  if (!onboardingSkippedTimestamp) {
    return false
  }

  const parsedTimestamp = parseInt(onboardingSkippedTimestamp, 10)
  const isExpired = (Date.now() - parsedTimestamp > ONBOARDING_SKIP_EXPIRATION_MS)

  if (isExpired) {
    localStorage.removeItem(LOCAL_STORAGE_ONBOARDING_SKIPPED_KEY)
    return false
  }

  return true
}
